export enum userRolEnum {
  normal = 0,
  admin = 1,
  moderator = 2,
  supervisor = 3
}
